var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpiImgAlertGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_161170",
    "data-name": "Group 161170",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.839,
    height: 24.706,
    viewBox: "0 0 23.839 24.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38849",
    "data-name": "Path 38849",
    d: "M15.1,15.732v4.082a7.763,7.763,0,0,1,1.692.274l2.247-3.542a11.8,11.8,0,0,0-3.938-.814",
    transform: "translate(-2.773 -2.889)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38850",
    "data-name": "Path 38850",
    d: "M4.654,18.936,7.538,21.82a7.8,7.8,0,0,1,4.827-2.005V15.733a11.856,11.856,0,0,0-7.712,3.2",
    transform: "translate(-0.855 -2.889)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38851",
    "data-name": "Path 38851",
    d: "M20.422,17.088,18.965,20.91a7.841,7.841,0,0,1,1.673,1.158l2.884-2.884a11.96,11.96,0,0,0-3.1-2.1",
    transform: "translate(-3.482 -3.138)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38852",
    "data-name": "Path 38852",
    d: "M0,28.427l4.082.018a7.8,7.8,0,0,1,2.025-5.2L3.223,20.363A11.858,11.858,0,0,0,0,28.427",
    transform: "translate(0 -3.739)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38853",
    "data-name": "Path 38853",
    d: "M27.828,28.427A11.858,11.858,0,0,0,24.6,20.363l-2.883,2.884a7.793,7.793,0,0,1,2.025,5.2Z",
    transform: "translate(-3.988 -3.739)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38854",
    "data-name": "Path 38854",
    d: "M18.708,17.381,16.72,20.516,14.2,24.482h0a1.719,1.719,0,1,0,1.472.86l1.736-4.555Z",
    transform: "translate(-2.295 -3.191)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38855",
    "data-name": "Path 38855",
    d: "M10.2,10.491H8.216L4.923,5.741l-1.012.825v3.925H2.2V0H3.911V5.009q.7-.861,1.4-1.657L8.145,0H10.1Q7.348,3.229,6.157,4.6Z",
    transform: "translate(-0.403)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38856",
    "data-name": "Path 38856",
    d: "M20.647,3.171a3.058,3.058,0,0,1-1.076,2.519,4.741,4.741,0,0,1-3.064.876H15.416V10.49H13.7V0h3.021a4.569,4.569,0,0,1,2.945.8,2.882,2.882,0,0,1,.98,2.368M15.416,5.123h.911a3.266,3.266,0,0,0,1.937-.459,1.671,1.671,0,0,0,.617-1.435,1.628,1.628,0,0,0-.553-1.349,2.729,2.729,0,0,0-1.722-.445H15.416Z",
    transform: "translate(-2.516)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148040",
    "data-name": "Rectangle 148040",
    width: 1.715,
    height: 10.491,
    transform: "translate(20.226)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiImgAlertGrid);
export default __webpack_public_path__ + "static/media/KPI_ImgAlertGrid.85eac6c3188628342d7dcde38d27138c.svg";
export { ForwardRef as ReactComponent };